module.exports = __webpack_public_path__ + "red_activity_icon-b5f402041ce1c932feee3bc9a219833e.png";